<svelte:options customElement={{ tag: 'vv-events', shadow: 'none' }} />

<script context="module">
    import appCssUrl from '../../app.css?inline';
    let style = '<style' + `>${appCssUrl}</style>`;
</script>

<script lang="ts">
    import { onMount } from 'svelte';
    import Router from 'svelte-spa-router';
    import { wrap } from 'svelte-spa-router/wrap';
    import Index from './Index.svelte';
    import RegisterPage from './RegisterPage.svelte';
    import ConfirmationPage from './ConfirmationPage.svelte';
    import { vvSettings } from '../../api/common';

    function redirectLegacyHashToServerRoute(): boolean {
        const hash = window.location.hash || '';
        const trimmed = hash.startsWith('#') ? hash.substring(1) : hash;
        const [path, query = ''] = trimmed.split('?');
        const registerMatch = path.match(/^\/Register\/(\d+)$/i);
        const confirmationMatch = path.match(/^\/Confirmation\/(\d+)$/i);
        if (!registerMatch && !confirmationMatch) return false;

        const association = (vvSettings as any)?.associationIdName;
        if (!association) return false;
        const siteNumber = (vvSettings as any)?.siteNumber;
        const siteSegment = siteNumber ? `/${siteNumber}` : '';
        const eventId = registerMatch ? registerMatch[1] : confirmationMatch![1];
        const actionPath = registerMatch ? 'Register' : 'ConfirmRegistration';
        const queryString = query ? `?${query}` : '';
        window.location.replace(`/${association}${siteSegment}/Events/${eventId}/${actionPath}${queryString}`);
        return true;
    }

    let initialHashWasInjected = false;

    if (redirectLegacyHashToServerRoute()) {
        // Full-page redirect kicked off; skip SPA hash initialization.
    } else {
        const initialRoute = (vvSettings as any)?.initialRoute as string | undefined;
        if ((!window.location.hash || window.location.hash === '#') && initialRoute) {
            const hashUrl = window.location.pathname + window.location.search + `#${initialRoute}`;
            history.replaceState(history.state, '', hashUrl);
            initialHashWasInjected = true;
        }
    }

    const routes = {
        '/': Index,
        '/Register/:id': wrap({
            component: RegisterPage,
        }),
        '/Confirmation/:id': wrap({
            component: ConfirmationPage,
        }),
        '*': Index
    };

    onMount(() => {
        if (initialHashWasInjected) {
            history.replaceState(history.state, '', window.location.pathname + window.location.search);
        }
    });
</script>

{@html style}

<div class="interfont">
    <Router {routes} />
</div>
